import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import Button from '../../../shared/ui/Button'
import { NavigationContext } from '../../../shared/ui/NavigationController'
import Section from '../../../shared/ui/Section'
import InputField from '../../../shared/ui/InputField'

import PreferredTrainersFormView from './PreferredTrainersFormView'

import { withStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const styles = theme => ({
  root: {
  },
})

const InviteProviderForm = ({ theme, classes, isEdit = false, initialData, trainers, onSave, onClose }) => {
  
  const navigationContext = useContext(NavigationContext)
  const [formData, setFormData] = useState({uid:initialData.uid})

  const validateAndSave = () => {
    let errors = {}

    if (Object.keys(errors).length > 0){
      console.log(errors)
      alert("Form Not Valid")
    }
    else{
        navigationContext.showLoadingDialog(true)
        if (formData.trainers && formData.trainers.length > 0){
          formData['preferred_trainer'] = formData.trainers[0] ? {uid: formData.trainers[0].uid } : {}
          formData['alt_trainer_1'] = formData.trainers[1] ? {uid: formData.trainers[1].uid } : {}
          formData['alt_trainer_2'] = formData.trainers[2] ? {uid: formData.trainers[2].uid } : {}
        }
        onSave(formData)
    }
  }

  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }
    
    setFormData(newFormData)
  }

  const onFormDataChange = (data) => {
    // alert("onFormDataChange: " + JSON.stringify(data, null, 2))
    setFormData({
      ...formData,
      ...data
    })
  }

  return (
    <Box>
      <Section title="Preferred Trainer" gutterBottom>
        <PreferredTrainersFormView
          classes={classes}
          theme={theme}
          edit={true}
          trainers={trainers || {}}
          formData={formData}
          onFormDataChange={onFormDataChange}
        />
      </Section>
      
      <Section title="Notes" gutterBottom>
        <InputField
          fieldName='notes'
          type='textarea'
          label=''
          value={formData.notes}
          onChange={onChange('notes')}
          />
      </Section>

      <Box display='flex' mt={1}>
        <Box flex={1} mr={1}>
          <Button variant='contained' onClick={() => validateAndSave()} style={{width:'100%'}}>
              Send Invitation
          </Button>
        </Box>
        <Box flex={1}>
          <Button variant='contained' color='default' onClick={onClose} style={{width:'100%'}}>
              Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(InviteProviderForm)
)
